export default __webpack_public_path__ + "static/media/homePageImage.8657fc88.svg";